module.exports = __webpack_public_path__ + "files/0ea98799dc69c8de1d1218def20dbba8.png";